import React from 'react'
import IntroduceWrapper from 'components/IntroduceWrapper/IntroduceWrapper'

export default function IntroduceContainer() {
    return (
        <IntroduceWrapper />
    )
}
